
import { Component, Vue } from "vue-property-decorator";
import IconOrders from "@/components/common/icon/IconOrders.vue";

@Component({
  name: "orders-header",
  components: {
    IconOrders,
  },
})
export default class OrdersHeader extends Vue {
  constructor() {
    super();
  }
}
